import {ColorTransform, getDefinitionByName, instanceOfClass} from "@goodgamestudios/createjs-utilities";
import {int} from "@goodgamestudios/math-utilities";
import {Poker2Constants} from "../../constants/Poker2Constants";
import {GiftsVO} from "../../gamevo/GiftsVO";
import {ItemsVO} from "../../gamevo/ItemsVO";
import {Poker2ShopData} from "../../model/components/Poker2ShopData";
import {getLogger, LoggingLevel} from "@goodgamestudios/logger";
import {Poker2LayoutManager} from "../Poker2LayoutManager";
import {AvatarHelperConstants} from "./AvatarHelperConstants";
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;

import Rectangle = createjs.Rectangle;

export class AvatarHelper {
    // Achtung, alle Items müssen im Interface.fla exitieren mit der Endung "_preview"
    // Abwechselnd Männlicher, Weiblicher Avatar
    // [ Avatar1, Avatar2, ... ] -> Avatar = [[ ItemId, ColorIndex ], [ ItemId, ColorIndex ], ...]
    private static FIX_AVATARE_WODIDS: any[] = [[[19002, 45014], [16041, 45014], [14049, -1], [20000, -1], [18000, 45002], [11003, 47005], [13044, -1], [10003, -1], [12010, 46001]], // AVATAR 1 (male)
        [[19020, 45005], [16103, 45005], [14042, 48007], [20000, -1], [18084, 45002], [11051, 47010], [13021, -1], [10012 - 1], [12040, 46001]],// AVATAR 2 (female)
        [[19002, 45005], [17020, 45005], [14000, -1], [20002, -1], [16081, 45002], [18000, 45002], [11003, 47002], [13002, -1], [10001, -1], [12000, 46001]], // AVATAR 3 (male)
        [[17000, 45006], [19021, 45006], [16132, 45002], [14044, 48000], [20001, -1], [18081, 45009], [13027, -1], [11052, 47005], [10018, -1], [12042, 46001]], // AVATAR 4 (female) usw.
        [[19000, 45002], [16040, 45002], [14049, -1], [20003, -1], [18000, 45014], [11011, 47003], [13002, -1], [10006, -1], [12002, 46006]], //Avatar 5(male)
        [[17001, 45014], [19020, 45014], [16132, 45002], [14043, 48006], [20000, -1], [18062, 45001], [11030, 47003], [13021, -1], [10011, -1], [12040, 46001]], //Avatar 6(female)
        [[19010, 45001], [16005, 45002], [21030, 45005], [14000, -1], [20001, -1], [16082, 45006], [18002, 45002], [13043, -1], [11000, 47004], [10005, -1], [12000, 46001]], // 7 (male)
        [[19024, 45006], [16134, 45006], [14021, 48000], [20001, -1], [16153, 45000], [18044, 45003], [13028, -1], [11053, 47000], [10014, -1], [12040, 46007]], //Avatar 8(female)
        [[19002, 45000], [17021, 45000], [21002, 45002], [14000, -1], [20000, -1], [16081, 45002], [18000, 45002], [11010, 47001], [13002, -1], [10001, -1], [12002, 46001]], //Avatar 9 (male)
        [[19020, 45002], [16133, 45006], [14025, 48000], [20003, -1], [16174, 45002], [18060, 45002], [23060, 45002], [13028, -1], [11034, 47002], [10012, -1], [12042, 46001]], //Avatar 10(female)
        [[19002, 45001], [14000, -1], [20002, -1], [18001, 45002], [11001, 47004], [13002, -1], [10007, -1], [12011, 46001], [16062, 45015]], // Avatar 11 (male)
        [[19024, 45006], [16136, 45006], [14046, 48008], [20001, -1], [18040, 45014], [23060, 45014], [13028, -1], [11052, 47003], [10017, -1], [12041, 46014]], //Avatar 12(female)

        [[19002, 45014], [16010, 45014], [14049, -1], [20001, -1], [18000, 45000], [11010, 47005], [13001, -1], [10007, -1], [12001, 46004]], //Avatar 13(male)
        [[19020, 45007], [14046, 48000], [20000, -1], [16176, 45005], [23060, 45014], [13042, -1], [11050, 47000], [10012, -1], [12040, 46009]],//Avatar 14 (female)
        [[19002, 45005], [14048, -1], [20002, -1], [16081, 45005], [18001, 45015], [13043, -1], [11002, 47005], [10001, -1], [12002, 46001]], //Avatar 15 (male)
        [[19022, 45015], [14021, 48004], [20003, -1], [16153, 45004], [18082, 45015], [23060, 45002], [11052, 47004], [13021, -1], [10011, -1], [12030, 46004]],//Avatar 16 (female)
        [[19000, 45014], [16000, 45015], [14000, -1], [20003, -1], [18001, 45007], [13046, -1], [11011, 47008], [10006, -1], [12000, 46002]],//Avatar 17 (male)
        [[19040, 45014], [17000, 45014], [14045, 48006], [20002, -1], [18081, 45002], [13040, -1], [11052, 47015], [10011, -1], [12030, 46007]],//Avatar 18 (female)
        [[19002, 45014], [14000, -1], [20001, -1], [16082, 45007], [18000, 45002], [11011, 47004], [13046, -1], [10001, -1], [12011, 46008]],//Avatar 19 (male)
        [[17001, 45009], [19022, 45008], [14020, 48008], [20000, -1], [18040, 45007], [11051, 47005], [13020, -1], [10014, -1], [12042, 46000]],//Avatar 20 (female)
        [[16005, 45002], [21030, 45005], [14000, -1], [20001, -1], [18001, 45009], [11000, 47011], [13045, -1], [10003, -1], [12000, 46010]],//Avatar 21 (male)
        [[19021, 45014], [16104, 45014], [14045, 48005], [20001, -1], [18081, 45000], [11050, 47009], [13040, -1], [10018, -1], [12040, 46001]],//Avatar 22 (female)
        [[19002, 45001], [14049, -1], [20000, -1], [18001, 45010], [11001, 47004], [13044, -1], [10006, -1], [16062, 45015], [12000, 46015]], //Avatar 23 (male)
        [[19020, 45005], [16103, 45005], [14046, 48006], [20000, -1], [16153, 45009], [18082, 45005], [13021, -1], [11051, 47005], [10011, -1], [12040, 46001]], //Avatar 24 (female)
        [[19002, 45001], [14000, -1], [20002, -1], [16082, 45014], [18001, 45002], [11001, 47001], [13002, -1], [10001, -1], [12000, 46010], [16062, 45015]], //Avatar 25 (male)
        [[19020, 45015], [16134, 45005], [14045, 48007], [20001, -1], [18082, 45005], [13021, -1], [11053, 47011], [10011, -1], [12042, 46004]], //Avatar 26 (female)
        [[19000, 45002], [16040, 45002], [14048, -1], [20003, -1], [18000, 45014], [11010, 47002], [13002, -1], [10008, -1], [12002, 46006]], //Avatar 27 (male)
        [[19020, 45014], [16104, 45009], [14042, 48002], [20000, -1], [18081, 45000], [11041, 47000], [13021, -1], [10011, -1], [12040, 46001]], //Avatar 28 (female)
        [[19000, 45002], [21030, 45015], [14049, -1], [20000, -1], [18000, 45015], [11011, 47000], [13002, -1], [10006, -1], [12002, 46006], [16061, 45008]], //Avatar 29 (male)
        [[19022, 45008], [16134, 45014], [14046, 48004], [20001, -1], [18081, 45007], [23060, 45014], [11052, 47001], [13021, -1], [10017, -1], [12041, 46010]]];

    constructor() {
    }

    /**
     * Erstellt aus den Preset-Avataren ein RandomArray mit Avataren,
     * abwechselnd männlich, weiblich
     */
    public static generatePresetAvatars(itemShop: Poker2ShopData): any[] {
        var resaltAvatars: any[] = new Array();
        for (var j: number = 0; j < AvatarHelper.FIX_AVATARE_WODIDS.length; j++) {
            var avatarData: any[] = AvatarHelper.FIX_AVATARE_WODIDS[j];
            var avatar: any[] = new Array();
            for (var k: number = 0; k < avatarData.length; k++) {
                var itemData: any[] = avatarData[k];

                var voObject: ItemsVO = itemShop.getItemVObyID(itemData[0]);
                if (voObject && voObject.colorTableId >= 0) {
                    var colorTables: any[] = itemShop.getColorTableByTableId(voObject.colorTableId);
                    var index: number = int(itemData[1]);
                    //						voObject.currentColor = "0x"+(colorTables[index] as ColorTableVO).color;
                    voObject.currentColor = itemShop.getColorById(index);
                    //						voObject.colorId = (colorTables[index] as ColorTableVO).id;
                    voObject.colorId = index;
                }
                avatar.push(voObject);
            }
            resaltAvatars.push(avatar);
        }
        return resaltAvatars;
        //			myAvatarIndex = MathBase.random( 0, randomAvatars.length-1 );
    }

    public static drawAvatarByItemArray(itemArray: any[], usePreview: boolean = false): Container {
        var avatar: Container = new Container();
        avatar.mouseChildren = false;
        itemArray.sort(AvatarHelper.onSortByLayerIndex);
        if (itemArray != null) {
            for (let entryList of itemArray) {
                var item: any = entryList;
                if (item === undefined) continue;

                if (!(instanceOfClass(item, "BoosterVO")) &&
                    (item.shopCategorySecondary != "shopScreen"))
                    avatar.addChild(AvatarHelper.drawItem(item, usePreview));
            }
        }
        return avatar;
    }

    public static drawItem(item: ItemsVO, usePreview: boolean = false, suffix: string = ""): Container {
        var epiName: string = (usePreview) ? "_preview" : "";
        var itemMC: Container = new Container();

        if (item.itemCategory == AvatarHelperConstants.AVATAR_SKIN) { // get skin
            itemMC.addChild(this.getSkinByItemId(item.id));
            return itemMC;
        }

        getLogger("getDefinitionByName").setLevel(LoggingLevel.NONE);
        try {
            var mcColorchangeClass = getDefinitionByName(item.getVisClassName() + "c" + epiName + suffix);
            if (mcColorchangeClass) {
                var mcColorchange: Container = new mcColorchangeClass();
                var ct: ColorTransform = new ColorTransform();
                ct.color = int(item.currentColor);
                mcColorchange.transform.colorTransform = ct;
                mcColorchange.cacheAsBitmap = true;
                mcColorchange.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
                itemMC.addChild(mcColorchange);
            }
        } catch (e) {
            //trace(e.message);
        }
        try {
            var mcClass = getDefinitionByName(item.getVisClassName() + epiName + suffix);
            if (mcClass) {
                var mcItem: Container = new mcClass();
                mcItem.cacheAsBitmap = true;
                mcItem.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
                itemMC.addChild(mcItem);
            }
        } catch (e) {
            //trace(e.message);
        }

        getLogger("getDefinitionByName").setLevel(LoggingLevel.ERROR);

        return itemMC;
    }

    private static getSkinByItemId(itemId: number): Container {
        var className: string = AvatarHelperConstants.AVATAR_SKIN + "_" + itemId + AvatarHelperConstants.AVATAR_PREVIEW;
        var mcClass: any = getDefinitionByName(className) as any;
        var mcItem: Container;
        if (mcClass) {
            mcItem = new mcClass();
            // color the skin based on the provided ids
            var ct: ColorTransform = new ColorTransform();
            ct.color = int(AvatarHelperConstants.avatarSkinColorsMap().get(itemId));
            mcItem["mc_skin"].transform.colorTransform = ct;
            mcItem["mc_skin"].cacheAsBitmap = true;
            mcItem["mc_skin"].doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
        } else {
            mcItem = new Container();
            mcItem.name = className + "_NOT_FOUND";
        }

        return mcItem;
    }

    public static drawGift(giftVo: GiftsVO): MovieClip {
        var itemMC: MovieClip;
        try {
            var mcClass: any = getDefinitionByName(giftVo.getVisClassName()) as any;
            itemMC = new mcClass();
            itemMC.mouseChildren = false;
            itemMC.cacheAsBitmap = true;
            if (itemMC.totalFrames > 0) {
                itemMC.gotoAndPlay(1);
            }

            // TODO: Hack to be able move/scale the new gift items for xmas 2011 with lower constrains
            if (giftVo.id >= 30090) {
                itemMC.scaleX = itemMC.scaleY /= Poker2LayoutManager.GAME_SCALE_FACTOR;
                return itemMC;
            }

            var bounds: Rectangle = itemMC.getBounds(null);
            var scaleFactor: number = (50 / bounds.width);
            if ((bounds.height * scaleFactor) > 50) {
                scaleFactor = (50 / bounds.height);
            }
            itemMC.scaleX = itemMC.scaleY = scaleFactor;
            itemMC.x = -((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
            itemMC.y = -((bounds.height * scaleFactor) / 2 + (bounds.top * scaleFactor));

        } catch (e) {
            //trace(e.message);
            itemMC = new MovieClip();
        }
        return itemMC;
    }

    private static onSortByLayerIndex(x: ItemsVO, y: ItemsVO): number {
        if (x.getItemLayer() < y.getItemLayer()) return -1;
        if (x.getItemLayer() > y.getItemLayer()) return 1;
        return 0;
    }
}

